import Experience from "./Experiance/Experiance.js";

const webGl = document.querySelector(".webgl");
const experience = new Experience(webGl);
